// extracted by mini-css-extract-plugin
export var table = "_xx-0";